import { useEffect, useState, useRef } from 'react';

import StyledWrapper from '../../../IndividualProgram/style';
import ApplicantProcess from '../../../../assets/customIcons/applicantProcess';
import { Tooltip } from '@mui/material';

const TitleTooltip = ({ cellValues }) => {
	const [isOverflowing, setIsOverflowing] = useState(false);
	const cardRowRef = useRef(null);
	useEffect(() => {
		if (cardRowRef.current) {
			setIsOverflowing(cardRowRef.current.scrollWidth > cardRowRef.current.clientWidth);
		}
	}, [cellValues]);

	return (
		<Tooltip arrow placement="top" title={isOverflowing ? `${cellValues?.formattedValue}` : ''}>
			<StyledWrapper.CellContainer
				data-testid={`cellContainer-${cellValues?.field}-${cellValues?.id}`}
			>
				<ApplicantProcess />
				<StyledWrapper.CardRowInfo ref={cardRowRef}>
					{cellValues?.formattedValue}
				</StyledWrapper.CardRowInfo>
			</StyledWrapper.CellContainer>
		</Tooltip>
	);
};

export default TitleTooltip;
